import React from 'react';
import { IconProps } from '../types/types';

const FTN: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#FF008C"/><path d="M8.183 16.25a.906.906 0 0 1-.485-.127.925.925 0 0 1-.453-.864.94.94 0 0 1 .168-.48l2.31-3.227-3.781-.376a1.008 1.008 0 0 1-.55-.22 1.032 1.032 0 0 1-.336-.491 1.063 1.063 0 0 1 .285-1.118l5.893-5.355a.887.887 0 0 1 .616-.242.932.932 0 0 1 .647.274.953.953 0 0 1 .093 1.196l-2.311 3.228 3.782.367c.2.02.39.099.547.226.158.127.275.297.339.491a1.07 1.07 0 0 1-.285 1.113l-5.886 5.362a.94.94 0 0 1-.593.243Z" fill="#fff"/></svg>
);

export default FTN;
